import { render, staticRenderFns } from "./MainPlanner2.vue?vue&type=template&id=f752613e&"
import script from "./MainPlanner2.vue?vue&type=script&lang=js&"
export * from "./MainPlanner2.vue?vue&type=script&lang=js&"
import style0 from "./MainPlanner2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports